import React, { useState } from "react";
import {
    Box,
    FormControl,
    FormLabel,
    Input,
    FormErrorMessage,
    Button,
} from "@chakra-ui/react";

const PasswordValidation = ({
    formLabelText,
    placeHolderText,
    handleSubmit,
}) => {
    const [password, setPassword] = useState("");

    // Password validation logic
    const isValid = password.length > 3 && password.length < 28;
    const isError = password.length > 0 && !isValid;

    return (
        <Box
            as="form"
            onSubmit={(e) => {
                e.preventDefault();
                handleSubmit(password);
            }}
        >
            <FormControl
                isInvalid={isError}
                border="1px"
                borderColor="gray.200"
                p={4}
            >
                <FormLabel fontWeight="bold">{formLabelText}</FormLabel>
                <Input
                    type="password"
                    placeholder={placeHolderText}
                    onChange={(e) => setPassword(e.target.value)}
                    w={{ base: "100%", lg: "38%" }}
                />
                <Button
                    type="submit"
                    width={{ base: "full", lg: "100px" }}
                    ml={{ base: "0", lg: "2" }}
                    mt={{ base: "2", lg: "-1" }}
                    isDisabled={!isValid}
                >
                    Submit
                </Button>
                {isError && (
                    <FormErrorMessage>
                        {password.length <= 3
                            ? "Password must be more than 3 characters long"
                            : "Password must be less than 28 characters long"}
                    </FormErrorMessage>
                )}
            </FormControl>
        </Box>
    );
};

export default PasswordValidation;
